import auth from './routes/auth';
import check from './routes/check';
import search from './routes/search';
import packages from './routes/packages';

const routes = [
  {
    path: '/',
    redirect: { name: 'search' },
  },
  ...auth,
  ...check,
  ...search,
  ...packages,
];

export default routes;
